module.exports = true;


//////////////////
// WEBPACK FOOTER
// /Users/bizqsoft/Documents/project/ibqs/ibqs-dip-2023-09-09/~/core-js/library/modules/_library.js
// module id = ../../../../core-js/library/modules/_library.js
// module chunks = 42